import React, { useState, useRef, useEffect } from 'react';
import { DefaultMessage } from "./jptr-default";

import { MdCloudDownload, MdSettings, MdHome, MdPerson, MdCoffee } from 'react-icons/md';
import { RiPaintFill } from 'react-icons/ri';
import { AiOutlineClear } from 'react-icons/ai';
import { IoMdCloudUpload } from 'react-icons/io';
import { TbIroning } from "react-icons/tb";

import { JiCopy, JiClean, JiInfo } from '../components/jptr-icons';


const VISIBILITY = {
    'show': 'visible',
    'hide': 'hidden'
};

const ICOSIZE = 25;


function CatHeadline({ name }) {
    return (
        <div className="noselect">
            <h1 className='headline' style={{ textTransform: 'uppercase' }}>{name}</h1>
        </div>
    );
}

function CatTopic({ ...props }) {

    const { name } = props;

    return (
        <div className="flx-Hc-1">
            <h2 style={{ textTransform: 'capitalize' }}>{name}</h2>
            <JiInfo className="ji-icon" />
        </div>
    );
}

function CatTitle({ name }) {
    return (
        <div className="nully">
            <h3 style={{ textTransform: 'capitalize' }}>{name}</h3>
        </div>
    );
}


function Btn({ BtnComponent, label, isDisabled = true, onClick }) {

    const preStyle = {
        display: 'inline-block',
        width: 'fit-content',
        padding: label === '' ? '0.7em' : '0.7em 1.2em'
    }

    const handlerClick = () => {
        try {
            if (onClick) {
                onClick()
            };
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <button onClick={handlerClick} disabled={!isDisabled} style={preStyle} >
            <div className='flx-Hc-1' style={{ textTransform: 'capitalize' }}>
                <BtnComponent size={ICOSIZE} />
                {label !== '' && (label)}
            </div>
        </button>
    );
}

function BtnCoffee(props) {
    return <Btn BtnComponent={MdCoffee} {...props} />;
}

function BtnCreate(props) {
    return <Btn BtnComponent={RiPaintFill} label='Create' {...props} />;
}

function BtnReset(props) {
    return <Btn BtnComponent={AiOutlineClear} label='Reset' {...props} />;
}

function BtnIroning(props) {
    return <Btn BtnComponent={TbIroning} label='Ironing' {...props} />;
}

function BtnDownload(
    {
        label = 'Download',
        infoText = DefaultMessage.MESSAGE.downloading,
        isDisabled,
        onDownload,
        ...props
    }
) {

    const [visi, setVisi] = useState(VISIBILITY.hide);

    const handlerDownload = async () => {
        setVisi(VISIBILITY.show);

        try {
            if (onDownload) {
                await onDownload()
            };
        } catch (error) {
            console.error("Error during download:", error);
        } finally {
            setVisi(VISIBILITY.hide);
        }
    };

    return (
        <div className="flx-Hc-1">
            <Btn BtnComponent={MdCloudDownload} iconSize={ICOSIZE} label={label} disabled={!isDisabled} onClick={handlerDownload} {...props} />
            <InfoPulse visible={visi} info={infoText} />
        </div>
    );
}

function BtnUpload({ label = 'Upload', iconSize = ICOSIZE, onUpload }) {
    const fileInputRef = useRef(null);

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file && onUpload) {
            onUpload(file);
        }
    };

    const style = {
        ...(label === '' && { padding: '0.5em' })
    };

    return (
        <>
            <Btn BtnComponent={IoMdCloudUpload} label={label} style={style} iconSize={iconSize} onClick={handleClick} />
            <input
                type="file"
                accept='.tif,.tiff'
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
        </>
    );
}

function InfoPulse({ info = "Pulsing...", visible }) {
    return (
        <h3 className="pulsing" style={{ visibility: visible }}>{info}</h3>
    );
}


function IdInput({ placeholder = '(optional) LINK-ID', value, onChange, isAvaliable = false }) {

    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    function handleReset() {

        const newValue = '';

        setInputValue(newValue);

        if (onChange) {
            onChange(newValue);
        }
    }

    function handleCopy() {
        navigator.clipboard.writeText(inputValue);
    }

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
        if (onChange) {
            onChange(newValue);
        }
    }

    // -- ToolTip

    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

    const handelPointerEnter = (event) => {
        setTooltipVisible(true);
        setTooltipPosition({ x: event.clientX, y: event.clientY });
        console.log('Pointer entered', inputValue);
    };

    const handelPointerLeave = () => {
        setTooltipVisible(false);
        console.log('Pointer left', inputValue);
    };

    const handlePointerMove = (event) => {
        if (tooltipVisible) {
            setTooltipPosition({ x: event.clientX, y: event.clientY });
        }
    };

    return (
        <div className="flx-Hc-1">
            <JiCopy className="ji-icon" onClick={handleCopy} />
            <div style={{ position: 'relative' }}>
                <input
                    type="text"
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={handleInputChange}
                    onPointerEnter={handelPointerEnter}
                    onPointerLeave={handelPointerLeave}
                    onPointerMove={handlePointerMove}
                />
                <div
                    style={{
                        width: '17px',
                        height: '17px',
                        backgroundColor: isAvaliable === true ? 'hsl(120, 100%, 45%)' : 'hsl(0, 100%, 45%)',
                        position: 'absolute',
                        top: '50%',
                        right: '15px',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        borderRadius: '50%'
                    }}>
                </div>
            </div>
            <JiClean className="ji-icon" onClick={handleReset} />

            {tooltipVisible && (
                <div className='tooltip nully'
                    style={{
                        position: 'absolute',
                        top: tooltipPosition.y + 10,
                        left: tooltipPosition.x + 10
                    }}>
                    <h4>Infobox</h4>
                    <p>{inputValue}</p>
                    <p>unset</p>
                </div>
            )}
        </div>
    );
}

function IdResult({ linkId }) {

    function handleCopy() {
        navigator.clipboard.writeText(linkId);
    }

    return (
        <div className="flx-Hc-1">
            <JiCopy className="ji-icon" onClick={handleCopy} />
            <h2 className={`clrspltID ${linkId === DefaultMessage.MESSAGE.calculating ? 'pulsing' : ''}`}>{linkId}</h2>
        </div>
    );
}

function IdInfo({ labelText = 'Information', ...props }) {

    const formatBytes = (mybytes) => {
        const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        let index = 0;

        while (mybytes >= 1024 && index < units.length - 1) {
            mybytes /= 1024;
            index++;
        }

        if (index === 0) {
            return `${mybytes} ${units[index]}`;
        }

        return `${mybytes.toFixed(2)} ${units[index]}`;
    };

    const formatDuration = (duration) => {
        return duration.toFixed(4) + ' sec.';
    }

    const formatValue = (key, value) => {
        if (key === 'bytes' || key === 'filesize') {
            return formatBytes(value);
        }
        if (key === 'duration') {
            return formatDuration(value);
        }
        return value;
    };

    const formatKey = (key) => {
        const words = key.split(/(?=[A-Z])/);
        return words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }

    return (
        <ColLow className="gap-1x25">
            <CatTitle name={labelText} />
            {Object.entries(props).map(([key, value]) => (
                <li key={key}>{formatKey(key)}: {formatValue(key, value)}</li>
            ))}
        </ColLow>
    );
}


function InpNumber({ name, value, disabled, onChange }) {

    function handleChange(event) {
        const newValue = Number(event.target.value);
        onChange(newValue);
    }

    return (
        <SingleRow style={{ opacity: disabled ? 0.4 : 1 }}> 
            <input
                type="number"
                name={name}
                value={value}
                onChange={handleChange}
                style={{ width: '4em' }}
                disabled={disabled}
            />
            <label>{name}</label>
        </SingleRow>
    );
}

function InpCheckbox({ name, value, onChange, disabled = false }) {

    function handleChange(event) {
        const newValue = event.target.checked;
        if (onChange)
            onChange(newValue);
    }

    return (
        <SingleRow style={{ opacity: disabled ? 0.4 : 1 }}>
            <input
                type="checkbox"
                name={name}
                checked={value}
                onChange={handleChange}
                disabled={disabled}
            />
            <label>{name}</label>
        </SingleRow>
    );
}

function InpRadio({ group, value, checked, onChange }) {
    return (
        <SingleRow>
            <input type="radio" name={group} value={value} onChange={onChange} checked={checked} />
            <label style={{ textTransform: 'capitalize' }}>{value}</label>
        </SingleRow>
    )
}

function InpSlider({ name, min = 0, max = 100, value, onSliderChange, unit = '%', step = 0.1 }) {

    const [sliderValue, setSliderValue] = useState(value);

    useEffect(() => {
        setSliderValue(value);
    }, [value, setSliderValue]);

    const handleSliderChange = (e) => {
        const newValue = Number(e.target.value);
        setSliderValue(newValue);
        if (onSliderChange) {
            onSliderChange(newValue);
        }
    };

    return (
        <SingleRow className="gap-0x25">
            <p style={{ width:'6em', textTransform: 'capitalize' }}><strong>{name}</strong></p>
            <input type="range" min={min} max={max} step={step} value={sliderValue} style={{ width: '13em' }} onChange={handleSliderChange} />
            <p style={{ width: '4em' }}><span id="limitUpperVal">{sliderValue.toFixed(1)}</span><span>{unit}</span></p>
       </SingleRow>
    );
}


function Icon({ IconComponent, labelText = '', iconSize = ICOSIZE, onClick, className = 'ico-btn' }) {

    const iconLabel = () => {
        return (
            <span>{labelText}</span>
        );
    }

    return (
        <div className="flx-Hc-1">
            <IconComponent size={iconSize} onClick={onClick} className={className} />
            {labelText !== '' && iconLabel()}
        </div>
    );
}

function IcoSettings(props) {
    return <Icon IconComponent={MdSettings} {...props} />;
}

function IcoHome(props) {
    return <Icon IconComponent={MdHome} {...props} />;
}

function IcoPerson(props) {
    return <Icon IconComponent={MdPerson} {...props} />;
}


const ColLow = ({ children, className = '', ...props }) => {
    return (
        <div className={`flx-Vl gap-0x75 nully ${className}`} {...props}>
            {children}
        </div>
    );
};

const Cols = ({ children, className = '', ...props }) => {
    return (
        <div className={`flx-Vl gap-1x5 nully ${className}`} {...props}>
            {children}
        </div>
    );
};

const ColContainer = ({ children, className = '', ...props }) => {
    return (
        <div className={`flx-Vl gap-2x5 nully ${className}`} {...props}>
            {children}
        </div>
    );
};

const SingleRow = ({ children, className = '', ...props }) => {
    return (
        <div className={`flx-Hc gap-1 ${className}`} {...props}>
            {children}
        </div>
    );
};

const SingleRowSpaced = ({ children, className = '', ...props }) => {
    return (
        <div className={`flx-Hc gap-spaceBetween ${className}`} {...props}>
            {children}
        </div>
    );
};

const GroupBox = ({ children, className = '', ...props }) => {
    return (
        <div className={`iflx-Vl gap-1x25 grpbx ${className}`} {...props}>
            {children}
        </div>
    );
};

const GroupContainer = ({ children, className = '', ...props }) => {
    return (
        <div className={`flx-Vl grpct ${className}`} {...props}>
            {children}
        </div>
    );
};

const InpRadioGroup = ({ children, className = '', ...props }) => {
    return (
        <div className={`flx-Vl gap-0x25 ${className}`} {...props}>
            {children}
        </div>
    );
};



export {
    CatHeadline,
    CatTopic,
    CatTitle,
    IdInput,
    IdResult,
    IdInfo,
    BtnCoffee,
    BtnIroning,
    BtnCreate,
    BtnDownload,
    BtnUpload,
    BtnReset,
    InpCheckbox,
    InpNumber,
    InpRadio,
    InpSlider,
    InfoPulse,
    IcoSettings,
    IcoHome,
    IcoPerson,
    ColLow,
    Cols,
    ColContainer,
    SingleRow,
    SingleRowSpaced,
    GroupBox,
    GroupContainer,
    InpRadioGroup
};